import React, { useState, useRef, useEffect } from 'react';
import { Row, Col, ListGroup, ListGroupItem, Button } from 'reactstrap';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';
import RichTextEditor from '../../../components/RichTextEditor';

//Api
import email_api from '../../../api/email_api';

//Helpers
import { showMessage } from '../../../helpers/message';

//Estado inicial do email
function initialStateEmail() {
    return {
        identificacao: "",
        corpo: "",
        finalidade: "",
        assunto: "",
        imagensConteudo: []
    }
}

export default function EditarEmail({ id, loading, setLoading, btnVoltar }) {
    const [email, setEmail] = useState(initialStateEmail);

    //Salva os dados do email
    function salvarEmail() {
        setLoading(true);
        email_api.Put(email).then(response => {
            showMessage("Sucesso", "Sucesso ao atualizar o email", "success", btnVoltar);
            setLoading(false);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
            setLoading(false);
        })
    }

    //Carrega os dados do email
    useEffect(() => {
        setLoading(true);
        email_api.GetItem(id).then(response => {
            setEmail(response.data);
            setLoading(false);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
            setLoading(false);
        });
    }, []);

    //Função que salva as imagens base64 adicionadas no conteudo html
    const setImage = (base64, e) => {
        const _email = {
            ...email,
            [e.target.name]: e.target.value,
            imagensConteudo: [
                ...email.imagensConteudo ? email.imagensConteudo : [],
                base64
            ]
        };
        setEmail(_email);
    }

    //Change dos dados do email
    const onChangeEmail = (e) => {
        const { name, value } = e.target;
        setEmail({
            ...email,
            [name]: value
        })
    }

    return (
        <>
            {loading && <Loading />}
            <MainCard btnVoltar={btnVoltar}>
                <Row>
                    <Col md="12" lg="12" className='mb-4'>
                        {email.finalidade != "Notificação" ?
                            <ListGroup>
                                <ListGroupItem className='text-light bg-dark fw-bold'>Palavras Chaves</ListGroupItem>
                                <ListGroupItem><span className="fw-bold">%IdentificacaoCadastro%</span> - {`Identificação do cadastrado`}</ListGroupItem>
                                <ListGroupItem><span className="fw-bold">%LinkAcesso%</span> - Link de acesso para o novo usuário alterar sua senha.</ListGroupItem>
                                {(email.finalidade == "Recuperação de Senha" || email.finalidade == "Cadastro Usuário" || email.finalidade == "Cadastro Gerador" || email.finalidade == "Cadastro Transportador" || email.finalidade == "Cadastro Destino") && <ListGroupItem><span className="fw-bold">%Senha%</span> - Senha temporária enviada para o e-mail do usuário.</ListGroupItem>}
                                {email.finalidade == "Cancelamento de Contrato" &&
                                <>
                                    <ListGroupItem><span className="fw-bold">%IdentificacaoLocalidade%</span> - Identificação da localidade do contrato.</ListGroupItem>
                                    <ListGroupItem><span className="fw-bold">%IdentificacaoModalidadeColeta%</span> - Identificação da modalidade de coleta do contrato.</ListGroupItem>
                                </>
                                }
                            </ListGroup>
                            :
                            <ListGroup>
                                <ListGroupItem className='text-light bg-dark fw-bold'>Palavras Chaves</ListGroupItem>
                                <ListGroupItem><span className="fw-bold">%dataNotificacao%</span> - Data em que a notificação foi feita</ListGroupItem>
                                <ListGroupItem><span className="fw-bold">%tipoNotificacao%</span> - Tipo da notificação realizada</ListGroupItem>
                                <ListGroupItem><span className="fw-bold">%observacao%</span> - Observações da notificação</ListGroupItem>
                            </ListGroup>
                        }
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="12">
                        <TextField maxLength={"100"} label={"Assunto"} name="assunto" value={email.assunto} onChange={onChangeEmail} />
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="12">
                        {id && email.corpo != "" ? <RichTextEditor saveImage={setImage} name="corpo" value={email.corpo} onChange={onChangeEmail} /> : ""}
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="12" className='d-flex align-items-center justify-content-center'>
                        <Button color='warning text-light' className='mt-4 px-3' onClick={salvarEmail}><FontAwesomeIcon className='pe-2' icon={faEdit} /> Editar</Button>
                    </Col>
                </Row>
            </MainCard>
        </>
    )
}
